import AddProductClassModal from './AddProductClassModal'
import EditProductClassModal from './EditProductClassModal'
import { heapEvent } from '@equipmentshare/heaper'

export function getAddProductClassModal( onSuccess?: () => void ) {
	return {
		component: AddProductClassModal,
		label: 'Add Product Class',
		onXClick: () => heapEvent( 'Inventory - Add Product Class Modal - Click - X button', {} ),
		onSuccess,
	}
}

export function getEditProductClassModal<T extends { id: string, catClass: string, categoryName: string, classification: string }>( productClass: T, onSuccess?: () => void ) {
	return {
		component: EditProductClassModal,
		componentProps: { productClass },
		label: 'Edit Product Class',
		onXClick: () => heapEvent( 'Inventory - Edit Product Class Modal - Click - X button', {} ),
		onSuccess,
	}
}
